import { getUrlParam } from '@/helpers/url';
import { GameRoundsResponse } from './types';

function getBaseUrl() {
    const serverUrl = getUrlParam('server');

    if (!serverUrl) throw Error('Connector server URL not found in url: ' + window.location.href);

    return serverUrl.replace('wss://', 'https://').replace(/\/(multigame|game-ws|game)$/, '');
}

export const getAllGameRounds = (
    userRef: string,
    gameId: string,
    pageSize = 50,
    page = 0,
): Promise<GameRoundsResponse> => {
    const params = new URLSearchParams({
        userRef,
        gameId,
        pageSize: pageSize.toString(),
        page: page.toString(),
    });
    return fetch(`${getBaseUrl()}/gameRounds?${params.toString()}`).then((res) => res.json());
};
